import * as React from 'react'
import { ReactElement, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Store } from '../../reducers'
import { DataPromise, shouldDispatchLoad } from '../../context/AxiosContext'
import { MenuItemKey } from '../../components/Menu'
import { timeBaseUrl } from '../Times'
import { FileAction } from '../../config/fileConfig'
import { AppAction } from '../../config/appConfig'
import TimeOverview, { parseFileSettingsToParams } from './TimeOverview'
import { ITimeListSettings } from '../../components/List/Time/TimeList'
import { TimeOverviewDto } from '../../config/registrationConfig'
import useAxios from '../../hooks/useAxios'
import { TimeAction } from '../../config/registration/timeConfig'

export default function GlobalTimeOverview(props): ReactElement {
    const axios = useAxios()
    const dispatch = useDispatch()
    const times = useSelector<Store, DataPromise<TimeOverviewDto[], ITimeListSettings>>(state => state.times.overview)

    useEffect(() => {
        dispatch({ type: AppAction.SetBreadcrumbs, payload: [MenuItemKey.Times] })
        dispatch({ type: FileAction.ResetCurrent })
    }, [props])

    useEffect(() => {
        if (shouldDispatchLoad(times)) {
            dispatch({
                type: TimeAction.GetOverview,
                payload: axios.get('/time', { params: parseFileSettingsToParams(times.settings) }),
            })
        }
    }, [times])

    return <TimeOverview baseUrl={timeBaseUrl} data={times.data} global />
}
